import { css } from "@emotion/react";

import { animations, colors } from "@styles";

export const productName = {
  base: css`
    text-overflow: ellipsis;
    overflow: hidden;
    ${animations.transition()}

    &&& {
      margin-bottom: 0;
    }
  `,

  changeOnHover: css`
    &:focus,
    &:hover {
      color: ${colors.primary};
    }
  `,
  noClip: css`
    white-space: normal;
  `,
};

export const nowrap = css`
  white-space: nowrap;
`;
